import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectorRef } from "@angular/core";
import { MatAccordion, MatExpansionPanel } from "@angular/material/expansion";

import { BaseSiteService } from "@spartacus/core";
import { UserAccountFacade } from "@spartacus/user/account/root";
import { Router } from '@angular/router';
import { take } from "rxjs/operators";
import { FaqService } from "../faq.service";

@Component({
    selector: 'app-faq',
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.scss'],
    standalone: false
})
export class FaqComponent implements OnInit, OnDestroy {

   @ViewChild(MatAccordion) accordions: MatAccordion;
   @ViewChild(MatExpansionPanel, { static: true }) outerPanel: MatExpansionPanel;

   faq: any[];
   userData: any;
   openById = {};
   expandAll = true;
   FaqDataSubscription: any;
   baseSiteId: string;
   vshEmail = 'vaccineshoppe.svc@sanofi.com';
   vaxEmail = 'VaxServe@vaxserve.com';

   constructor(
      private readonly faqService: FaqService,
      private readonly cd: ChangeDetectorRef,
      private readonly user: UserAccountFacade,
      private readonly router: Router,
      private baseSiteService: BaseSiteService,
   ) {
   }

   ngOnInit() {
      this.baseSiteService.getActive().pipe(take(1)).subscribe(res => this.baseSiteId = res);
      this.faqService.getFAQ();
      this.FaqDataSubscription = this.faqService.faqList$.subscribe((res) => {
         if (res.hasOwnProperty("items")) {
            this.faq = res['items'];
            this.cd.detectChanges();
         }
      });
   }

   goToPatientEducation() {
      this.router.navigateByUrl('patientEducation');
   }

   toggle(index) {

      this.faq[index].questions.forEach(question => question['open'] = true);


   }

   showOnlyQuestions(index) {

      this.faq[index].questions.forEach(question => question['open'] = false);

   }

   toggleAll(): void {







   }

   ngOnDestroy() {
      this.FaqDataSubscription.unsubscribe();
   }
}
